import React, { useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { useParams } from 'react-router-dom';
import { format, parseISO } from 'date-fns';

import { useStore } from 'core/store';
import { Label } from 'core';

import useStyles from './preview-footer.styles';

const formatDate = (dateStr) => {
  if (!dateStr) {
    return '';
  }
  return format(parseISO(dateStr), 'MM/dd/yyyy');
};

const formatDateTime = (dateStr) => {
  if (!dateStr) {
    return '';
  }
  return format(parseISO(dateStr), "MM/dd/yyyy '@' h:mm a 'EST'");
};

function PreviewFooter({ onSubmit, policyPreview }) {
  const classes = useStyles();
  const { policyId } = useParams();
  const {
    account: {
      policies: { list: policiesList }
    }
  } = useStore();

  useEffect(() => {
    window.onbeforeunload = () => true;
  }, []);

  const originalPolicy = policiesList.find((p) => p.id === policyId);
  const isExistingSegment = originalPolicy?.segments?.find(
    (s) => s.id === policyPreview?.changeDetails?.targetSegmentId
  );

  return (
    <div className={classes.container}>
      <Grid container className={classes.footerInner}>
        <div className={classes.footerItem}>
          <Label className={classes.label} type="subtitle1">
            Changes were requested
          </Label>
          <Label className={classes.subLabel} type="subtitle2">
            This draft is set to <span>{isExistingSegment ? 'edit existing change' : 'create new change'}</span> on{' '}
            <span>{formatDate(policyPreview.changeDetails.effectiveDate)}</span>. Last edited{' '}
            <span>{formatDateTime(policyPreview.changeDetails.updatedDateTime)}</span> by{' '}
            <span>{policyPreview.createdBy.username}</span>.
          </Label>
        </div>
        <Grid className={classNames(classes.footerItem, classes.last)}>
          <Button
            variant="contained"
            color="primary"
            data-cy="preview-policy-changes"
            onClick={onSubmit}
            className={classes.btn}
          >
            <Label className={classes.btnLabel}>Preview requested changes</Label>
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

PreviewFooter.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  policyPreview: PropTypes.object.isRequired
};

export default memo(PreviewFooter);
